import React from 'react';

export default function SecuritySeverityBadge({ severity }) {
  const level = (severity || '').toLowerCase();
  return (
    <span className={`vx-sec-severity-badge vx-sec-severity-badge--${level}`}>
      {severity}
    </span>
  );
}
